import Autocomplete from "@mui/material/Autocomplete"
import Chip from "@mui/material/Chip"
import TextField from "@mui/material/TextField"

import { AUTOCOMPLETE_IN_DIALOG_PROPS } from "../autocompleteInDialogProps"

function sameId(a, b) {
  return String(a) === String(b)
}

/**
 * Several fixed options (`[{value, label}]`) as chips. The filter stores the
 * option values, the same ids a single pick stored before.
 */
export default function ChoiceMultiSelect({
  label,
  choices,
  value,
  onChange,
  loading = false,
}) {
  const selectedValues = Array.isArray(value)
    ? value
    : value == null || value === ""
    ? []
    : [value]
  const selected = selectedValues.map(
    (item) =>
      choices.find((choice) => sameId(choice.value, item)) || {
        value: item,
        label: loading ? "…" : String(item),
      }
  )

  return (
    <Autocomplete
      multiple
      size="small"
      loading={loading}
      options={choices}
      filterSelectedOptions
      value={selected}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(a, b) => sameId(a?.value, b?.value)}
      onChange={(_event, next) => onChange(next.map((option) => option.value))}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            key={String(option.value)}
            variant="filled"
            size="small"
            label={option.label}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => <TextField {...params} label={label} />}
      sx={{ width: "100%" }}
      {...AUTOCOMPLETE_IN_DIALOG_PROPS}
    />
  )
}
